/**
 * Cart page: dynamic updates via Shopify Cart API.
 * Increment, decrement, delete and quantity input update the cart via API
 * and the DOM is updated immediately from the API response (no full section refresh).
 */
(function () {
  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getMoneyFormat() {
    var root = document.getElementById('cart-page-root');
    return (root && root.getAttribute('data-money-format')) || '{{amount}}';
  }

  function formatMoney(cents, moneyFormat) {
    if (moneyFormat == null || moneyFormat === '') {
      return (cents / 100).toFixed(2);
    }
    moneyFormat = String(moneyFormat).replace(/\bRs\.?\s*/gi, '₹ ');
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/\./, ','));
  }

  function escapeHtml(s) {
    if (s == null) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function updateHeaderCount(count) {
    var el = document.querySelector('[data-gaurya-cart-count]');
    if (!el) return;
    if (count > 0) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.style.display = 'flex';
    } else {
      el.style.display = 'none';
    }
  }

  function dispatchCartUpdated(cart) {
    var count = (cart && cart.item_count != null) ? cart.item_count : 0;
    updateHeaderCount(count);
    document.dispatchEvent(new CustomEvent('gaurya:cart:updated', { detail: { item_count: count } }));
  }

  function getCollectionsUrl() {
    var root = document.getElementById('cart-page-root');
    return (root && root.getAttribute('data-collections-url')) || getRoot() + 'collections/all';
  }

  /**
   * Update the cart page DOM from the cart API response (items, totals, empty state).
   */
  function updateCartDOM(cart) {
    var formWrap = document.getElementById('cart-form-wrap');
    var emptyWrap = document.getElementById('cart-empty-wrap');
    var itemsList = document.querySelector('.cart-page__items');
    var moneyFormat = getMoneyFormat();

    if (!cart || cart.item_count === 0) {
      if (formWrap) formWrap.style.display = 'none';
      if (emptyWrap) emptyWrap.style.display = 'block';
      dispatchCartUpdated(cart || { item_count: 0 });
      return;
    }

    if (formWrap) formWrap.style.display = '';
    if (emptyWrap) emptyWrap.style.display = 'none';

    if (itemsList && cart.items && cart.items.length > 0) {
      itemsList.innerHTML = cart.items.map(function (item) {
        var key = escapeHtml(item.key || '');
        var url = escapeHtml(item.url || '#');
        var imgSrc = item.image ? escapeHtml(item.image) : '';
        var title = escapeHtml(item.product_title || item.title || 'Product');
        var rawVariantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        rawVariantTitle = rawVariantTitle.replace(/\b5\s*L\b/gi, '5 litre');
        var variantTitle = escapeHtml(rawVariantTitle);
        var unitPrice = item.final_price != null ? item.final_price : (item.price != null ? item.price : 0);
        var linePrice = item.final_line_price != null ? item.final_line_price : (item.line_price != null ? item.line_price : (unitPrice * (item.quantity || 1)));
        var qty = Math.max(0, parseInt(item.quantity, 10) || 0);
        var unitPriceFormatted = formatMoney(unitPrice, moneyFormat);
        var linePriceFormatted = formatMoney(linePrice, moneyFormat);

        return '<li class="cart-item" role="row" data-key="' + key + '" data-variant-id="' + (item.variant_id || '') + '">' +
          '<div class="cart-item__cell cart-item__cell--product" role="cell">' +
            '<div class="cart-item__image-wrap"><a href="' + url + '">' +
              (imgSrc ? '<img class="cart-item__image" src="' + imgSrc + '" alt="" width="110" height="110" loading="lazy">' : '<div class="cart-item__image" style="background: rgba(0,0,0,0.05);"></div>') +
            '</a></div>' +
            '<div class="cart-item__details">' +
              '<h2 class="cart-item__title"><a href="' + url + '">' + title + '</a></h2>' +
              (variantTitle ? '<p class="cart-item__variant">' + variantTitle + '</p>' : '') +
            '</div></div>' +
          '<div class="cart-item__cell cart-item__cell--price" role="cell">' +
            '<span class="cart-item__price-label">Price</span>' +
            '<span class="cart-item__price gaurya-money">' + unitPriceFormatted + '</span></div>' +
          '<div class="cart-item__cell cart-item__cell--quantity" role="cell">' +
            '<div class="cart-item__quantity">' +
              '<label class="cart-item__qty-label">Quantity</label>' +
              '<div class="cart-item__qty-controls">' +
                '<button type="button" class="cart-item__qty-btn" data-cart-qty-minus aria-label="Decrease quantity">−</button>' +
                '<input type="number" name="updates[]" value="' + qty + '" min="0" class="cart-item__qty-input" aria-label="Quantity">' +
                '<button type="button" class="cart-item__qty-btn" data-cart-qty-plus aria-label="Increase quantity">+</button>' +
              '</div></div></div>' +
          '<div class="cart-item__cell cart-item__cell--total" role="cell">' +
            '<span class="cart-item__total-label">Total</span>' +
            '<span class="cart-item__line-total gaurya-money">' + linePriceFormatted + '</span></div>' +
          '<div class="cart-item__cell cart-item__cell--remove" role="cell">' +
            '<button type="button" class="cart-page__remove-btn" data-cart-remove aria-label="Remove">' +
              '<img class="cart-page__remove-icon" src="' + getRoot() + 'assets/delete_icon.svg" alt="" width="22" height="22" loading="lazy">' +
            '</button></div></li>';
      }).join('');
    }

    var totalPrice = cart.total_price != null ? cart.total_price : 0;
    var totalFormatted = formatMoney(totalPrice, moneyFormat);
    var summaryValueSpans = document.querySelectorAll('.cart-page__summary-row span:last-child, .cart-page__summary-row--total span:last-child');
    for (var i = 0; i < summaryValueSpans.length; i++) {
      summaryValueSpans[i].textContent = totalFormatted;
    }

    dispatchCartUpdated(cart);
  }

  function setLoading(loading) {
    var root = document.getElementById('cart-page-root');
    if (root) {
      if (loading) root.classList.add('cart-page--loading');
      else root.classList.remove('cart-page--loading');
    }
  }

  function changeQuantity(key, quantity) {
    var root = getRoot();
    setLoading(true);
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.message || 'Cart update failed');
          return data;
        });
      })
      .then(function (cart) {
        updateCartDOM(cart);
        setLoading(false);
        return cart;
      })
      .catch(function (err) {
        setLoading(false);
        throw err;
      });
  }

  function removeItem(key) {
    return changeQuantity(key, 0);
  }

  function getRowFromTarget(target) {
    return target.closest && target.closest('.cart-item');
  }

  function getKeyFromRow(row) {
    return row && row.getAttribute && row.getAttribute('data-key');
  }

  function getQtyFromRow(row) {
    var input = row && row.querySelector && row.querySelector('.cart-item__qty-input');
    return input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;
  }

  function updateAllQuantities() {
    var form = document.getElementById('cart-form');
    if (!form) return Promise.resolve();

    var rows = form.querySelectorAll('.cart-item');
    var updates = {};
    for (var i = 0; i < rows.length; i++) {
      var key = rows[i].getAttribute('data-key');
      var input = rows[i].querySelector('.cart-item__qty-input');
      if (key && input) {
        updates[key] = Math.max(0, parseInt(input.value, 10) || 0);
      }
    }
    if (Object.keys(updates).length === 0) return Promise.resolve();

    var root = getRoot();
    setLoading(true);
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.message || 'Cart update failed');
          return data;
        });
      })
      .then(function (cart) {
        updateCartDOM(cart);
        setLoading(false);
        return cart;
      })
      .catch(function (err) {
        setLoading(false);
        throw err;
      });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-cart-remove]')) {
        e.preventDefault();
        var btn = target.closest('[data-cart-remove]');
        var row = getRowFromTarget(btn);
        var key = getKeyFromRow(row);
        if (key) {
          btn.disabled = true;
          removeItem(key).catch(function () { btn.disabled = false; });
        }
        return;
      }

      if (target.closest('[data-cart-qty-minus]')) {
        e.preventDefault();
        var row = getRowFromTarget(target);
        var key = getKeyFromRow(row);
        var qty = getQtyFromRow(row);
        if (key != null && qty > 0) {
          changeQuantity(key, qty - 1);
        }
        return;
      }

      if (target.closest('[data-cart-qty-plus]')) {
        e.preventDefault();
        var row = getRowFromTarget(target);
        var key = getKeyFromRow(row);
        var qty = getQtyFromRow(row);
        if (key != null) {
          changeQuantity(key, qty + 1);
        }
        return;
      }

      if (target.closest('[data-cart-update-all]')) {
        e.preventDefault();
        var btn = target.closest('[data-cart-update-all]');
        btn.disabled = true;
        updateAllQuantities()
          .then(function () { btn.disabled = false; })
          .catch(function () { btn.disabled = false; });
      }

      var checkoutLink = (target && target.closest) ? target.closest('#cart-checkout-link') : null;
      if (checkoutLink) {
        e.preventDefault();
        e.stopPropagation();
        var href = checkoutLink.getAttribute('href') || (getRoot() + 'checkout');
        updateAllQuantities()
          .then(function () {
            window.location.href = href;
          })
          .catch(function () {
            window.location.href = href;
          });
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('cart-item__qty-input')) return;
      var row = getRowFromTarget(e.target);
      var key = getKeyFromRow(row);
      var qty = getQtyFromRow(row);
      if (key != null && qty >= 0) {
        changeQuantity(key, qty);
      }
    });

    document.addEventListener('blur', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('cart-item__qty-input')) return;
      var row = getRowFromTarget(e.target);
      var key = getKeyFromRow(row);
      var qty = getQtyFromRow(row);
      if (key != null && qty >= 0) {
        changeQuantity(key, qty);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
